import React from "react";
import "./Reset.css";

export default function ResetSuccessPage() {
  return (
    <div className="reset-wrapper">
      <img src="/logo.png" alt="Pod Recs" className="reset-logo" />
      <h1 className="reset-title">You're all set! 🎉</h1>
      <p className="reset-subtitle">
        Your password has been updated. You can now log in to the Pod Recs app.
      </p>
    </div>
  );
}
